import "./book.css";

import React from "react";

import { BOOK, BOOKING_ENGINE_URL, CONTACT_DETAILS } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { PageBackground } from "../general/PageSections";

//Semper booking engine, embedded as on Wix. It doesn't tell the page how tall it is, so the frame fills the window
//below the header and scrolls inside itself
const Book = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);

  return (
    <div className={"book"}>
      <PageMeta
        title={BOOK.TITLE}
        description={BOOK.DESCRIPTION}
      />
      <PageBackground />
      <h1 className={"visually-hidden"}>{BOOK.TITLE}</h1>

      <div className={"book-frame"}>
        {isLoaded ? null : <p className={"book-loading"}>Loading availability...</p>}
        <iframe
          src={BOOKING_ENGINE_URL}
          title={"Check availability and book a room"}
          onLoad={() => setIsLoaded(true)}
        />
      </div>

      <p className={"book-help"}>
        Trouble booking?{" "}
        <a
          href={BOOKING_ENGINE_URL}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          Open the booking page in a new tab
        </a>
        , or call us on{" "}
        <a href={CONTACT_DETAILS.TEL.link}>{CONTACT_DETAILS.TEL.label}</a>
        .
      </p>
    </div>
  );
};

export default Book;
